<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="على-أعتاب-القمر">
<h1>2<span dir="rtl">- على أعتاب القمر</span></h1>
<p><span dir="rtl">يُرهقُني</span></p>
<p><span dir="rtl">الهواءُ الذي أتنفَّسُ</span></p>
<p><span dir="rtl">أعرفُ أنَّها الدمعةُ الأخيرةُ</span></p>
<p><span dir="rtl">قبلَ الاحتضارِ</span></p>
<p><span dir="rtl">ألمحُ داخلي سفرًا</span></p>
<p><span dir="rtl">وأنَّني على ضفةِ القمرِ</span></p>
<p><span dir="rtl">أجلسُ وقد غادرَني كلُّ شيءٍ</span></p>
<p><span dir="rtl">متأمِّلًا تلك الكرةَ الخضراءَ</span></p>
<p><span dir="rtl">متعَبٌ تأخذُني أمورٌ</span></p>
<p><span dir="rtl">أرغَمَتني الجلوسَ على هذه الضفةِ</span></p>
<p><span dir="rtl">أحوالٌ كثيرةٌ هناكَ</span></p>
<p><span dir="rtl">أردتُ التَّحدثَ وحضَرت</span></p>
<p><span dir="rtl">لَم أستطِعِ البَوحَ هناك</span></p>
<p><span dir="rtl">وإنِ استطعتُ</span></p>
<p><span dir="rtl">تصطدمُ الكلماتُ بتلك الأحلام المكسورةِ</span></p>
<p><span dir="rtl">يأخذُها الواقعُ</span></p>
<p><span dir="rtl">يرغمُها</span></p>
<p><span dir="rtl">سلوكًا إلى عالمٍ آخَرَ</span></p>
<p><span dir="rtl">المعلومِ المجهولِ</span></p>
<p><span dir="rtl">إلى ضفةٍ أخرى</span></p>
<p><span dir="rtl">تزيلُ منها اللحنَ الذي تريدُ له الوصولَ</span></p>
<p><span dir="rtl">تتلاشَى تلك الصورُ المزيّنةُ</span></p>
<p><span dir="rtl">تتكسَّرُ اللوحاتُ الجميلةُ</span></p>
<p><span dir="rtl">تتخبَّطُ الألوانُ في بعضِها</span></p>
<p><span dir="rtl">تدمعُ دينونتُها</span></p>
<p><span dir="rtl">تعثرُ عليها عبورَ عتمةِ النَّهارِ</span></p>
<p><span dir="rtl">يُحيلُها الأنينُ والدموعُ</span></p>
<p><span dir="rtl">إلى صمتٍ موجوعٍ مِن تفاسيرِ الكلامِ</span></p>
<p><span dir="rtl">هكَذا</span></p>
<p><span dir="rtl">تتغيَّرُ الفرائضُ</span></p>
<p><span dir="rtl">كأنَّها تسيرُ إلى هاويةِ عباداتٍ مرتجلةٍ</span></p>
<p><span dir="rtl">وطقوسُ القيدِ المسجونِ</span></p>
<p><span dir="rtl">داخلَ ذلك الصَّمتِ</span></p>
<p><span dir="rtl">مِن العالمِ الآخَرِ</span></p>
<p><span dir="rtl">مِن ذلك العدمِ الموجودِ في الموجودِ</span></p>
<p><span dir="rtl">تلك الضفةُ</span></p>
<p><span dir="rtl">تُرغِمُني البَوحَ بالكثيرِ</span></p>
<p><span dir="rtl">وحيدًا لا أحدَ يسمعُ</span></p>
<p><span dir="rtl">ومع ذلك الصَمتِ</span></p>
<p><span dir="rtl">أترقَّبُ العودةَ مِن البعيدِ</span></p>
<p><span dir="rtl">أحمد كريم عز الدين.. سوريا</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?3593cc2c